import env from '../utils/env';
import authWeb from './web';
import authWeixin from './weixin';
import authNative from './native';
import authQuickApp from './quickApp';
import enterpriseList from '@/DATA/enterprise-list.js';
import authHbQuickApp from './hbQuickApp.js';
import authMiniprogram from './miniprogram';

function get() {
  if ( enterpriseList.indexOf( env.partner ) >= 0 ) {
    return authWeb;
  } else if ( env.isMiniProgram ) {
    return authMiniprogram
  } else if ( env.isWeixin ) {
    return authWeixin;
  } else if (env.isNative) {
    return authNative;
  } else if (env.isQuickApp) {
    if ( env.quickAppName === 'hbgj' ) {
      return authHbQuickApp;
    } else {
      return authQuickApp;
    }
  } else {
    return authWeb;
  }
}

export default get();



// WEBPACK FOOTER //
// ./src/auth/index.js